<template>
  <div class="technology" v-track="{functionName: '新技术'}" @click="handleClick">
    <img src="@/assets/images/technology/technology-enter.png" class="img-bg" alt="">
  </div>
</template>
<script>
export default {
  name: 'Technology',
  data() {
    return {
      dayDetails: {
        questionTitle: ''
      },
      questionImage: {}
    }
  },
  mounted() {
  },
  methods: {
    handleClick() {
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/technologyIndex`)
      this.$router.push({
        path: '/technologyIndex'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.technology {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 14px 10px;
  align-items: center;
  .img-bg {
    width: 100%;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/Technology.vue